"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.IconWrapper = exports.ExpandableWrapper = exports.ExpandableContentWrapper = exports.ExpandButtonWrapper = exports.ButtonWrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const style = process.env.NODE_ENV === "production" ? {
  name: "19fnwux",
  styles: "display:grid;grid-auto-flow:column;background-color:#ffffff;align-content:center;align-items:center"
} : {
  name: "1bxdxz4-style",
  styles: "display:grid;grid-auto-flow:column;background-color:#ffffff;align-content:center;align-items:center;label:style;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const outlinestyle = process.env.NODE_ENV === "production" ? {
  name: "1d1mls9",
  styles: "outline:1px dotted #212121;outline:5px auto -webkit-focus-ring-color"
} : {
  name: "1o1kwhm-outlinestyle",
  styles: "outline:1px dotted #212121;outline:5px auto -webkit-focus-ring-color;label:outlinestyle;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1pwey9c5"
} : {
  target: "e1pwey9c5",
  label: "Wrapper"
})(style, ";");
const ButtonWrapper = exports.ButtonWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1pwey9c4"
} : {
  target: "e1pwey9c4",
  label: "ButtonWrapper"
})("cursor:pointer;display:flex;&>span{", style, " width:100%;text-align:initial;font-weight:normal;color:unset;}&:focus-visible{", outlinestyle, ";}");
const ExpandButtonWrapper = exports.ExpandButtonWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1pwey9c3"
} : {
  target: "e1pwey9c3",
  label: "ExpandButtonWrapper"
})("position:relative;cursor:pointer;display:flex;&>span{display:grid;grid-auto-flow:column;align-content:center;align-items:center;width:100%;text-align:initial;font-weight:normal;color:unset;}&:focus-visible{", outlinestyle, " svg:last-of-type{", outlinestyle, ";}}");
const ExpandableWrapper = exports.ExpandableWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1pwey9c2"
} : {
  target: "e1pwey9c2",
  label: "ExpandableWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1cuahnq",
  styles: "display:grid;background-color:#ffffff"
} : {
  name: "1cuahnq",
  styles: "display:grid;background-color:#ffffff",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const ExpandableContentWrapper = exports.ExpandableContentWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1pwey9c1"
} : {
  target: "e1pwey9c1",
  label: "ExpandableContentWrapper"
})();
const IconWrapper = exports.IconWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1pwey9c0"
} : {
  target: "e1pwey9c0",
  label: "IconWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1o54221",
  styles: "position:absolute;top:calc(50% - 6px)"
} : {
  name: "1o54221",
  styles: "position:absolute;top:calc(50% - 6px)",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});